export default __webpack_public_path__ + "static/media/laptop.9c96beff.svg";